(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	ngModule.directive('orderDetail', function ($Orders, SplashModalService, $rootScope, ModalService, $pageArray, $Products, $SchemaModal) {
		return {
			scope: {
				order: '='
			},
			templateUrl: 'directives/orderDetail/section.html',
			controller: function($scope, $Products) {
                var order = $scope.order;

                // $scope.addItem = function() {
                //     var scope = $rootScope.$new();
                //     scope.products = $Products.all;
                //
                //     var modal = ModalService.showModal({
                //       scope: scope,
                //       templateUrl: 'directives/orderDetail/addProductForm.html',
                //       controller: function($scope, $element, close) {
                //           $scope.itemTotal = 0;
                //           $scope.itemCount = 0;
                //
                //           $scope.setTotals = function() {
                //               $scope.itemCount = _.reduce($scope.product.properties, function(memo, property){
                //                   return property.purchased ? memo + 1 : memo;
                //               }, 0);
                //
                //               $scope.itemTotal = ($scope.item.basePrice || 0) + _.reduce($scope.product.properties, function(memo, property){
                //                   return property.purchased ? property.purchased.price + memo : 0;
                //               }, 0);
                //
                //               // $scope.itemTotal = $scope.itemTotal * $scope.item.quantity;
                //
                //               console.log('Total for Item', $scope.itemTotal);
                //           };
                //
                //           $scope.$on('selectionChanged', function() {
                //               $scope.setTotals();
                //           });
                //
                //           $scope.$watch('product', function(newValue, oldValue) {
                //               if (newValue !== oldValue) {
                //                   $scope.setTotals();
                //               }
                //           });
                //
                //           $scope.submitForm = function(form, data) {
                //               var item = angular.copy($scope.product);
                //               if (!_.isArray(order.items)) order.items = [];
                //
                //               order.items.unshift(item);
                //
                //               $element.modal('hide');
                //               close(null, 500);
                //           };
                //
                //       }
                //     }).then(function(modal) {
                //         // The modal object has the element built, if this is a bootstrap modal
                //         // you can call 'modal' to show it, if it's a custom modal just show or hide
                //         // it as you need to.
                //         modal.element.modal();
                //     });
                // };
                //
                // $scope.addPackage = function() {
                //     var scope = $rootScope.$new();
                //
                //     /* Attach the order to the modal scope. */
                //     scope.order = $scope.order;
                //
                //     if (!$scope.order.store) {
                //         alert('Sorry, there is no store attached to this order.');
                //         return;
                //     }
                //
                //     /* ensure we have a packages array on the order. */
                //     if (!_.isArray($scope.order.packages)) $scope.order.packages = [];
                //
                //     scope.packages = $scope.order.store.packages || [];
                //
                //     var modal = ModalService.showModal({
                //       scope: scope,
                //       templateUrl: 'directives/orderDetail/addStorePackage.html',
                //       controller: function($scope, $element, close) {
                //           $scope.addPackage = function(data) {
                //               /* Push the package data onto the order packages array. */
                //               scope.order.packages.push(data);
                //
                //               /* Close the modal. */
                //               $element.modal('hide');
                //               close(null, 500);
                //           };
                //       }
                //     }).then(function(modal) {
                //         // The modal object has the element built, if this is a bootstrap modal
                //         // you can call 'modal' to show it, if it's a custom modal just show or hide
                //         // it as you need to.
                //         modal.element.modal();
                //     });
                //
                // };

                $scope.$watch('order.note', function(newValue, oldValue) {
                    if (newValue !== oldValue) {
                        $scope.order.$save();
                    }
                });

                $scope.printInvoice = function() {
                    alert('coming soon');
                };

                $scope.emailInvoice = function() {
                    alert('coming soon');
                };

                $scope.printReceipt= function() {
                    alert('coming soon');
                };

                $scope.emailReceipt = function() {
                    alert('coming soon');
                };

                $scope.editPaymentInfo = function() {

                    var submit = function(form, data, close) {
                        close();
                        $scope.order.$save();
                    };

                   var form = [
                       'payment.name',
                       'payment.school',
                       {
                           key: 'payment.method',
                           type: 'select',
                           titleMap: [
                            { value: 'credit', name: 'Credit Card' },
                            { value: 'invoice', name: 'Invoice' },
                            { value: 'check', name: 'Check' }
                          ]
                       },
                       'payment.code',
                       {
                         type: 'submit',
                         title: 'Submit'
                       }
                   ];

                   if (!_.isObject($scope.order.payment)) $scope.order.payment = {};

                   $SchemaModal.open('Edit Payment Information', $scope.order, $Orders.schema, form, submit);
                };

                $scope.save = function() {
                    $scope.order.$save();
                };

                $scope.editDetails = function() {

                    var submit = function(form, data, close) {
                        close();
                        $scope.order.$save();
                    };

                   var form = [
                       'customer.name',
                       'customer.email',
                       'customer.phone',
                       {
                         type: 'submit',
                         title: 'Submit'
                       }
                   ];

                   if (!_.isObject($scope.order.customer)) $scope.order.customer = {};

                   $SchemaModal.open('Edit Details', $scope.order, $Orders.schema, form, submit);
                };
			}
		};
	});

})();
